import './CoralTopbar.scss'

import { StickyBar } from '@bob/library'
import { useSignUpVisibility } from '@websrc/App/Hooks/useSignUpVisibility'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapCoralTopbar } from '@websrc/DataMappers/mapCoralTopbar'
import { stickBar } from '@websrc/MainTopbar/MainTopbar.css'
import React, { FC, useEffect, useLayoutEffect, useRef, useState } from 'react'

import { CoralLogo } from '../CoralLogo/CoralLogo'
import { CTA } from '../CTA'

export interface CoralTopbarProps {
  topbar?: ReturnType<typeof mapCoralTopbar>
}

export const CoralTopbar: FC<CoralTopbarProps> = ({ topbar }) => {
  const [moveCTAtoBottom, setMoveCTAtoBottom] = useState(false)
  const { isSignUpButtonsIntersecting } = useSignUpVisibility()
  const [ctaWidth, setCTAWidth] = useState(0)
  const logoRef = useRef<SVGSVGElement>(null)
  const navRef = useRef<HTMLDivElement>(null)
  const ctaRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const updateNavDisplay = () => {
      if (logoRef.current && ctaRef.current && navRef.current) {
        const logoWidth = logoRef.current.getBoundingClientRect().width || 0

        const logoComputedStyle = getComputedStyle(logoRef.current)
        const logoMarginLeft = parseFloat(logoComputedStyle.marginLeft)
        const logoMarginRight = parseFloat(logoComputedStyle.marginRight)
        const logoTotalWidth = logoWidth + logoMarginLeft + logoMarginRight

        const ctaComputedStyle = getComputedStyle(ctaRef.current)
        const ctaMarginLeft = parseFloat(ctaComputedStyle.marginLeft)
        const ctaMarginRight = parseFloat(ctaComputedStyle.marginRight)
        const ctaTotalWidth = ctaWidth + ctaMarginLeft + ctaMarginRight

        const navWidth = navRef.current.offsetWidth || 0
        const isNavContentTooWide = logoTotalWidth + ctaTotalWidth > navWidth

        setMoveCTAtoBottom(isNavContentTooWide)
      }
    }

    window.addEventListener('resize', updateNavDisplay)
    updateNavDisplay()

    return () => {
      window.removeEventListener('resize', updateNavDisplay)
    }
  }, [ctaWidth])

  useEffect(() => {
    const checkCTAWidth = () => {
      if (ctaRef.current) {
        const width = ctaRef.current.offsetWidth || 0
        if (width > 0) setCTAWidth(width)
      }
    }

    window.addEventListener('resize', checkCTAWidth)
    checkCTAWidth()
    return () => window.removeEventListener('resize', checkCTAWidth)
  }, [])

  return (
    <>
      <StickyBar bgColor={'grayWhite'} className={stickBar.zIndex} noContainer={true}>
        <div className={'coral-topbar-container'}>
          <div className={'coral-topbar__content'} ref={navRef}>
            <CoralLogo className={'coral-topbar__logo'} ref={logoRef} />
            {topbar?.cta?.text && (
              <div
                ref={ctaRef}
                style={
                  moveCTAtoBottom || isSignUpButtonsIntersecting
                    ? { visibility: 'hidden' }
                    : { visibility: 'visible' }
                }
              >
                <CTA
                  className={'coral-topbar__cta'}
                  cta={topbar?.cta}
                  onClick={() => {
                    matomo.trackEvent(
                      'engagement',
                      'all',
                      ['coral top menu'],
                      [topbar?.cta?.text],
                      'menu'
                    )
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </StickyBar>
      <div
        className={'coral-topbar-container--bottom'}
        style={{
          visibility: moveCTAtoBottom && !isSignUpButtonsIntersecting ? 'visible' : 'hidden',
        }}
      >
        <CTA
          className={'coral-topbar__cta coral-topbar__cta--fullwidth'}
          cta={topbar?.cta || null}
          onClick={() => {
            matomo.trackEvent('engagement', 'all', ['coral top menu'], [topbar?.cta?.text], 'menu')
          }}
        />
      </div>
    </>
  )
}
